import { type IChallengeCarouselItem } from '../../../../common/interfaces';
import { NO_IMAGE_PLACEHOLDER } from '../../common/const';
import { useRuntimeCommunity } from '../../../../context';
import {
  Slide,
  SlideDescription,
  SlideImage,
  SlideLink,
  SlideStatIcon,
  SlideStatItem,
  SlideStats,
  SlideSubtitle,
  SlideTitle
} from './ChallengeCarouselSlide.styled';

export interface CarouselSlideProps {
  slideData: IChallengeCarouselItem;
  hideDescription: boolean;
  isActive?: boolean;
}

export const ChallengeCarouselSlide = ({ slideData, hideDescription, isActive = false }: CarouselSlideProps) => {
  const { colors } = useRuntimeCommunity();
  return (
    <Slide data-testid="challenge-carousel-slide" aria-hidden={!isActive}>
      <SlideLink href={slideData?.linkUrl} title={slideData?.title} tabIndex={isActive ? 0 : -1}>
        <SlideImage>
          <img src={slideData.imageUrl || NO_IMAGE_PLACEHOLDER} alt={slideData?.title} />
          {!hideDescription && (
            <SlideDescription id="slide-description" bgColor={colors.button}>
              <div>
                <SlideTitle>{slideData?.title}</SlideTitle>
                <SlideSubtitle>{slideData?.subtitle || ''}</SlideSubtitle>
              </div>
              <SlideStats>
                <SlideStatItem>
                  <SlideStatIcon className="mdl-icon -s">
                    <svg>
                      <use href="#idea" />
                    </svg>
                  </SlideStatIcon>
                  {slideData?.ideaCount}
                </SlideStatItem>
              </SlideStats>
            </SlideDescription>
          )}
        </SlideImage>
      </SlideLink>
    </Slide>
  );
};
